'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_TextNode(initialText) {
  this.zi = null;
  this.zj = null;
  this.zi = $j_java$002elang$002e$002dObject.$m_s_None$();
  this.zj = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().Tn(initialText);
}
export { $c_Lcom_raquo_laminar_nodes_TextNode as $c_Lcom_raquo_laminar_nodes_TextNode };
$p = $c_Lcom_raquo_laminar_nodes_TextNode.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_TextNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_TextNode() {
}
export { $h_Lcom_raquo_laminar_nodes_TextNode as $h_Lcom_raquo_laminar_nodes_TextNode };
$h_Lcom_raquo_laminar_nodes_TextNode.prototype = $p;
$p.Bh = (function() {
  return this.zi;
});
$p.lf = (function(maybeNextParent) {
  this.zi = maybeNextParent;
});
$p.lq = (function(maybeNextParent) {
});
$p.dL = (function(parentNode) {
  $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().qP(parentNode, this, (void 0));
});
$p.XZ = (function() {
  return this.zj.data;
});
$p.aV = (function() {
  return this.zj;
});
var $d_Lcom_raquo_laminar_nodes_TextNode = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_nodes_TextNode, "com.raquo.laminar.nodes.TextNode", ({
  iO: 1,
  bM: 1,
  ab: 1,
  c7: 1
}));
export { $d_Lcom_raquo_laminar_nodes_TextNode as $d_Lcom_raquo_laminar_nodes_TextNode };
